/**
 * ADA / WCAG 2.1 AA Accessibility Fixes
 * Store: cabana-miami.com
 * Theme: Minimog (Copy of Cabana Miami 2025)
 * Author: Sial Tech
 * Date: April 2026
 * Version: 3 - includes opposing counsel audit fixes
 */

(function () {
  'use strict';

  /* =========================================================
     1. SKIP TO CONTENT LINK
     ========================================================= */
  function injectSkipLink() {
    if (document.getElementById('ada-skip-link')) return;

    var skip = document.createElement('a');
    skip.id = 'ada-skip-link';
    skip.href = '#MainContent';
    skip.textContent = 'Skip to content';
    skip.setAttribute('tabindex', '0');

    var style = document.createElement('style');
    style.id = 'ada-skip-link-style';
    style.textContent = [
      '#ada-skip-link {',
      '  position: absolute;',
      '  top: -100px;',
      '  left: 16px;',
      '  z-index: 99999;',
      '  background: #000;',
      '  color: #fff;',
      '  padding: 12px 20px;',
      '  font-size: 14px;',
      '  font-weight: 600;',
      '  text-decoration: none;',
      '  border-radius: 0 0 4px 4px;',
      '  transition: top 0.2s;',
      '}',
      '#ada-skip-link:focus {',
      '  top: 0;',
      '  outline: 3px solid #fff;',
      '  outline-offset: 2px;',
      '}'
    ].join('\n');

    document.head.appendChild(style);
    document.body.insertBefore(skip, document.body.firstChild);
  }

  /* =========================================================
     2. FOCUS VISIBLE STYLES
     ========================================================= */
  function injectFocusStyles() {
    if (document.getElementById('ada-focus-style')) return;

    var style = document.createElement('style');
    style.id = 'ada-focus-style';
    style.textContent = [
      'a:focus-visible,',
      'button:focus-visible,',
      '[role="button"]:focus-visible,',
      'input:focus-visible,',
      'select:focus-visible,',
      'textarea:focus-visible,',
      '[tabindex]:focus-visible {',
      '  outline: 3px solid #005fcc !important;',
      '  outline-offset: 3px !important;',
      '  border-radius: 2px;',
      '}',
      'a:focus,',
      'button:focus,',
      '[role="button"]:focus,',
      'input:focus,',
      'select:focus,',
      'textarea:focus {',
      '  outline: 3px solid #005fcc !important;',
      '  outline-offset: 3px !important;',
      '}',
      'body:not(.ada-keyboard-user) a:focus,',
      'body:not(.ada-keyboard-user) button:focus,',
      'body:not(.ada-keyboard-user) [role="button"]:focus {',
      '  outline: none !important;',
      '}'
    ].join('\n');

    document.head.appendChild(style);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') document.body.classList.add('ada-keyboard-user');
    });
    document.addEventListener('mousedown', function () {
      document.body.classList.remove('ada-keyboard-user');
    });
  }

  /* =========================================================
     3. MAIN NAVIGATION KEYBOARD SUPPORT
     ========================================================= */
  function initDesktopMenuKeyboard() {
    var menuItems = document.querySelectorAll('.m-menu__item--parent > .m-menu__link--main');

    menuItems.forEach(function (link) {
      var li = link.parentElement;
      var megaMenu = li.querySelector('.m-mega-menu');
      if (!megaMenu) return;

      var menuId = 'm-mega-' + Math.random().toString(36).substr(2, 6);
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-controls', menuId);
      megaMenu.setAttribute('id', menuId);
      megaMenu.setAttribute('role', 'region');

      link.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var isOpen = li.classList.contains('m-menu__item--active');
          closeAllDesktopMenus();
          if (!isOpen) openDesktopMenu(li, link);
        }
        if (e.key === 'Escape') {
          closeAllDesktopMenus();
          link.focus();
        }
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          openDesktopMenu(li, link);
          var firstItem = megaMenu.querySelector('a, button');
          if (firstItem) firstItem.focus();
        }
      });

      megaMenu.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeAllDesktopMenus();
          link.focus();
        }
      });

      li.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!li.contains(document.activeElement)) {
            closeSingleDesktopMenu(li, link);
          }
        }, 50);
      });
    });

    var menuEl = document.querySelector('.m-header__menu');
    if (menuEl && menuEl.closest('nav') === null) {
      var nav = document.createElement('nav');
      nav.setAttribute('aria-label', 'Main navigation');
      menuEl.parentNode.insertBefore(nav, menuEl);
      nav.appendChild(menuEl);
    }

    var menuBar = document.querySelector('.m-header__menu .m-menu');
    if (menuBar) {
      menuBar.setAttribute('role', 'menubar');
      menuBar.setAttribute('aria-label', 'Main menu');
    }
  }

  function openDesktopMenu(li, link) {
    var header = li.closest('header') ||
                 document.querySelector('.m-header') ||
                 document.querySelector('[data-section-type="header"]');
    if (header) header.classList.add('m-mega-active');
    li.classList.add('m-menu__item--active');
    li.classList.add('ada-open');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  function closeSingleDesktopMenu(li, link) {
    li.classList.remove('m-menu__item--active');
    li.classList.remove('ada-open');
    if (link) link.setAttribute('aria-expanded', 'false');
    if (!document.querySelector('.m-menu__item--active')) {
      var header = li.closest('header') ||
                   document.querySelector('.m-header') ||
                   document.querySelector('[data-section-type="header"]');
      if (header) header.classList.remove('m-mega-active');
    }
  }

  function closeAllDesktopMenus() {
    document.querySelectorAll('.m-menu__item.ada-open').forEach(function (li) {
      var link = li.querySelector('.m-menu__link--main');
      closeSingleDesktopMenu(li, link);
    });
    document.querySelectorAll('.m-mega-active').forEach(function (el) {
      el.classList.remove('m-mega-active');
    });
  }

  /* =========================================================
     4. MOBILE MENU DRAWER - KEYBOARD + FOCUS TRAP
     ========================================================= */
  function initMobileMenuKeyboard() {
    var drawer = document.getElementById('m-menu-drawer');
    if (!drawer) return;

    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Navigation menu');

    var openBtn = document.querySelector('.m-hamburger-box, .m-header__hamburger button');

    var observer = new MutationObserver(function () {
      var isOpen = drawer.classList.contains('open');
      if (isOpen) {
        trapFocus(drawer);
        setTimeout(function () {
          var first = getFocusableElements(drawer)[0];
          if (first) first.focus();
        }, 300);
      } else {
        releaseFocusTrap();
        if (openBtn) openBtn.focus();
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var closeBtn = drawer.querySelector('.m-menu-drawer__close, [data-close-menu-drawer]');
        if (closeBtn) closeBtn.click();
        if (openBtn) openBtn.focus();
      }
    });
  }

  /* =========================================================
     5. CART DRAWER - FOCUS MANAGEMENT + FOCUS TRAP + ESC
     ========================================================= */
  function initCartDrawerAccessibility() {
    var cartDrawer = document.getElementById('MinimogCartDrawer');
    if (!cartDrawer) return;

    cartDrawer.setAttribute('role', 'dialog');
    cartDrawer.setAttribute('aria-modal', 'true');
    cartDrawer.setAttribute('aria-label', 'Shopping cart');

    var inner = cartDrawer.querySelector('.m-cart-drawer__inner');

    var observer = new MutationObserver(function () {
      var isOpen = cartDrawer.classList.contains('m-cart-drawer--active');
      if (isOpen) {
        setTimeout(function () {
          var firstFocusable = getFocusableElements(inner)[0];
          if (firstFocusable) firstFocusable.focus();
        }, 350);
        trapFocus(inner);
      } else {
        releaseFocusTrap();
        var trigger = document.querySelector('.m-cart-icon-bubble');
        if (trigger) trigger.focus();
      }
    });
    observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });

    cartDrawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var closeBtn = cartDrawer.querySelector('.m-cart-drawer__close');
        if (closeBtn) closeBtn.click();
      }
    });
  }

  /* =========================================================
     6. FOCUS TRAP UTILITY
     ========================================================= */
  var activeTrapHandler = null;
  var activeTrapElement = null;

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return !el.closest('[hidden]') && el.offsetParent !== null;
    });
  }

  function trapFocus(container) {
    releaseFocusTrap();
    activeTrapElement = container;
    activeTrapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var focusable = getFocusableElements(container);
      if (focusable.length === 0) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey) {
        if (document.activeElement === first) { e.preventDefault(); last.focus(); }
      } else {
        if (document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    container.addEventListener('keydown', activeTrapHandler);
  }

  function releaseFocusTrap() {
    if (activeTrapHandler && activeTrapElement) {
      activeTrapElement.removeEventListener('keydown', activeTrapHandler);
      activeTrapHandler = null;
      activeTrapElement = null;
    }
  }

  /* =========================================================
     7. ARIA IMPROVEMENTS
     ========================================================= */
  function fixAriaRoles() {

    /* Icon-only buttons - assign aria-label from class context */
    document.querySelectorAll('button').forEach(function (btn) {
      var text = btn.textContent.trim();
      if (!text && !btn.getAttribute('aria-label') && !btn.getAttribute('aria-labelledby')) {
        if (btn.querySelector('svg')) {
          var cls = btn.className || '';
          var label = 'Button';
          if (/close/i.test(cls)) label = 'Close';
          else if (/cart/i.test(cls)) label = 'View cart';
          else if (/search/i.test(cls)) label = 'Search';
          else if (/menu|hamburger/i.test(cls)) label = 'Open menu';
          else if (/prev|previous/i.test(cls)) label = 'Previous';
          else if (/next/i.test(cls)) label = 'Next';
          else if (/wishlist/i.test(cls)) label = 'Add to wishlist';
          else if (/account/i.test(cls)) label = 'Account';
          btn.setAttribute('aria-label', label);
        }
      }
    });

    /* Fix non-descriptive "View Collection" links */
    document.querySelectorAll('a.m-button, a.m-richtext__button').forEach(function (link) {
      var text = link.textContent.trim().replace('\u2192', '').trim();
      if (text === 'View Collection' || text === 'View Collections') {
        var section = link.closest('[class*="m-section"], section, .m-richtext');
        if (section) {
          var heading = section.querySelector('h1, h2, h3, h4');
          if (heading) {
            link.setAttribute('aria-label', text + ' - ' + heading.textContent.trim());
          }
        }
      }
    });

    /* Fix social media and all target="_blank" links - add "opens in new window" */
    document.querySelectorAll('a[target="_blank"]').forEach(function (link) {
      var label = link.getAttribute('aria-label') || link.textContent.trim();
      if (label && label.indexOf('new window') === -1 && label.indexOf('new tab') === -1) {
        link.setAttribute('aria-label', label + ' (opens in new window)');
      }
    });

    /* Fix wishlist buttons - add product name to aria-label */
    document.querySelectorAll('.m-wishlist-button, button[data-product-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var currentLabel = btn.getAttribute('aria-label') || '';
      if (handle && currentLabel.toLowerCase() === 'add to wishlist') {
        var card = btn.closest('[data-product-id], .m-product-card');
        if (card) {
          var title = card.querySelector('.m-product-card__name, .m-product-card__title a, h3 a');
          if (title) {
            btn.setAttribute('aria-label', 'Add ' + title.textContent.trim() + ' to wishlist');
          }
        }
      }
    });

    /* Images without alt text - skip logos and meaningful brand images */
    document.querySelectorAll('img:not([alt])').forEach(function (img) {
      var isLogo = img.closest('.m-logo, .m-footer--block, a[href="/"]');
      if (!isLogo) {
        img.setAttribute('alt', '');
        img.setAttribute('role', 'presentation');
      }
    });

    /* Form inputs without labels */
    document.querySelectorAll('input, select, textarea').forEach(function (input) {
      if (!input.getAttribute('aria-label') && !input.getAttribute('aria-labelledby')) {
        var placeholder = input.getAttribute('placeholder');
        if (placeholder) input.setAttribute('aria-label', placeholder);
      }
    });

    /* Search forms */
    document.querySelectorAll('form[action*="search"], .m-search-form').forEach(function (form) {
      if (!form.getAttribute('role')) form.setAttribute('role', 'search');
    });

    /* Header landmark */
    var header = document.querySelector('#shopify-section-header, .m-header');
    if (header && !header.closest('header')) {
      var headerEl = document.createElement('header');
      header.parentNode.insertBefore(headerEl, header);
      headerEl.appendChild(header);
    }

    /* Footer landmark */
    var footer = document.querySelector('#shopify-section-footer, .m-footer');
    if (footer && !footer.closest('footer')) {
      var footerEl = document.createElement('footer');
      footerEl.setAttribute('aria-label', 'Site footer');
      footer.parentNode.insertBefore(footerEl, footer);
      footerEl.appendChild(footer);
    }

    /* Breadcrumb - add nav landmark, ol structure, aria-current */
    var breadcrumb = document.querySelector('.m-breadcrumb');
    if (breadcrumb && !breadcrumb.closest('nav')) {
      var bNav = document.createElement('nav');
      bNav.setAttribute('aria-label', 'Breadcrumb');
      breadcrumb.parentNode.insertBefore(bNav, breadcrumb);
      bNav.appendChild(breadcrumb);
    }
    /* Mark current page in breadcrumb */
    var currentBreadcrumb = document.querySelector('.m-breadcrumb--item-current');
    if (currentBreadcrumb) {
      currentBreadcrumb.setAttribute('aria-current', 'page');
    }

    /* Accordion sections - wrap button in heading if not already */
    document.querySelectorAll('.m-collapsible--button').forEach(function (btn) {
      var parent = btn.parentElement;
      if (parent && !/^H[1-6]$/i.test(parent.tagName)) {
        var h3 = document.createElement('h3');
        h3.className = 'm-collapsible--heading';
        h3.style.cssText = 'margin:0;font-size:inherit;font-weight:inherit;';
        btn.parentNode.insertBefore(h3, btn);
        h3.appendChild(btn);
      }
    });
  }

  /* =========================================================
     8. PRODUCT FORM ACCESSIBILITY
     ========================================================= */
  function fixProductForms() {

    /* Variant selectors */
    document.querySelectorAll('.m-product-option, .swatch-label, [data-option-name]').forEach(function (el) {
      if (!el.getAttribute('aria-label') && !el.getAttribute('title')) {
        var label = el.getAttribute('data-option-name') || el.getAttribute('data-value') || el.textContent.trim();
        if (label) el.setAttribute('aria-label', label);
      }
    });

    /* Quantity inputs */
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', 'Quantity');
    });

    /* Add to cart live region */
    document.querySelectorAll('[name="add"], .m-add-to-cart-btn, button[data-add-to-cart]').forEach(function (btn) {
      if (!btn.getAttribute('aria-live')) btn.setAttribute('aria-live', 'polite');
    });

    /* Variant picker fieldset grouping */
    document.querySelectorAll('.m-product-option--wrapper, [data-option-name]').forEach(function (wrapper) {
      var optionName = wrapper.getAttribute('data-option-name') ||
                       wrapper.querySelector('.option-label--title, .m-product-option--label');
      if (optionName && wrapper.tagName !== 'FIELDSET') {
        var label = typeof optionName === 'string' ? optionName : optionName.textContent.trim();
        if (!wrapper.getAttribute('role')) {
          wrapper.setAttribute('role', 'group');
          wrapper.setAttribute('aria-label', label);
        }
      }
    });
  }

  /* =========================================================
     9. ANNOUNCEMENT BAR
     ========================================================= */
  function fixAnnouncementBar() {
    var bar = document.querySelector('.m-announcement-bar, .m-topbar');
    if (bar) {
      bar.setAttribute('role', 'region');
      bar.setAttribute('aria-label', 'Announcement');
    }
  }

  /* =========================================================
     10. MAIN CONTENT FOCUSABLE FOR SKIP LINK
     ========================================================= */
  function fixMainContent() {
    var main = document.getElementById('MainContent');
    if (main && !main.getAttribute('tabindex')) {
      main.setAttribute('tabindex', '-1');
    }
  }

  /* =========================================================
     INIT
     ========================================================= */
  function init() {
    injectSkipLink();
    injectFocusStyles();
    fixMainContent();
    initDesktopMenuKeyboard();
    initMobileMenuKeyboard();
    initCartDrawerAccessibility();
    fixAriaRoles();
    fixProductForms();
    fixAnnouncementBar();

    document.addEventListener('shopify:section:load', function () {
      fixAriaRoles();
      fixProductForms();
      initCartDrawerAccessibility();
      initDesktopMenuKeyboard();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
